// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForIndicatorCircle = makeThemedStyles('Range.IndicatorCircle', () => ({
  IndicatorCircle: {
    borderRadius: '50%',
    width: '0.5rem',
    height: '0.5rem',
    alignSelf: 'center',
    display: 'inline-block'
  },

  circleLarge: {
    width: '1.3em',
    height: '1.3em'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const IndicatorCircle: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForIndicatorCircle();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{
        ...(props?.style || {}),
        ...{ backgroundColor: props?.color, width: props?.size, height: props?.size }
      }}
      className={clsx(styles.IndicatorCircle, {
        [styles.circleLarge]: isVariantEnabled(props, 'circleLarge')
      })}
    />
  );
};
export default IndicatorCircle;
